import React from "react";
import { useLocation } from "react-router-dom";
var TrackingService = /** @class */ (function () {
    function TrackingService() {
    }
    TrackingService.buildFlowTrackerObj = function (bookingState, ibeCompletedBooking) {
        if (!bookingState)
            return;
        if (!bookingState.selectedLocalProduct)
            return;
        var lobTitle = bookingState.selectedLocalProduct && bookingState.selectedLocalProduct.fields.displayTitle;
        if (bookingState.selectedLocalProduct._parent) {
            lobTitle = bookingState.selectedLocalProduct._parent.fields.displayTitle;
        }
        var searchDate = bookingState.selectedDate.format("YYYY-MM-DD");
        var adults = bookingState.guests.adults;
        var children = bookingState.guests.children;
        var email = (bookingState.guestsInfo.email || "").trim().toLowerCase();
        if (!lobTitle) {
            return;
        }
        var obj = Object.create(null);
        if (email) {
            obj.m5UserId = this.md5(email);
        }
        if (ibeCompletedBooking) {
            obj.bookingNumber = ibeCompletedBooking.bookingNumber;
            obj.bookingId = ibeCompletedBooking.bookingId;
        }
        obj.page = Object.create(null);
        obj.page.lob = lobTitle;
        obj.page.searchDate = searchDate;
        obj.page.adults = adults;
        obj.page.children = children;
        var _this = this;
        //const bookingToQuote = getBookingToQuoteRequest(bookingState); //bookingState.booking.quotedBookingItem.bookingToQuote ||
        var trackedProducts = [];
        if (bookingState.selectedIBEUnit) {
            trackedProducts.push({
                "id": bookingState.selectedIBEProduct && bookingState.selectedIBEProduct.code,
                "name": bookingState.selectedLocalProduct && bookingState.selectedLocalProduct.fields.displayTitle,
                "cost": bookingState.selectedIBEUnit && (bookingState.selectedIBEUnit._totalPrice || bookingState.selectedIBEUnit.price),
                "package": null,
                "lob": lobTitle,
                "arrival_date": bookingState.selectedIBEProduct && _this.getCleanDateStr(bookingState.selectedIBEProduct.startDate)
            });
            if ((bookingState.selectedExtraProducts || "").length) {
                bookingState.selectedExtraProducts.forEach(function (extraProduct) {
                    trackedProducts.push({
                        "id": extraProduct.ibeProduct.code,
                        "name": extraProduct.ibeProduct._localProduct && extraProduct.ibeProduct._localProduct.fields.displayTitle,
                        "cost": extraProduct.ibeProduct.price || extraProduct.ibeProduct.units && extraProduct.ibeProduct.units[0].price,
                        "package": null,
                        "lob": lobTitle,
                        "arrival_date": _this.getCleanDateStr(extraProduct.ibeProduct.startDate)
                    });
                });
            }
            if (bookingState.selectedTransportation && bookingState.selectedTransportation.ibeUnit && bookingState.selectedTransportation.ibeUnit._selectedPickup) {
                trackedProducts.push({
                    "id": bookingState.selectedTransportation.ibeProduct.code,
                    "name": bookingState.selectedTransportation.localProduct && bookingState.selectedTransportation.localProduct.fields.displayTitle,
                    "cost": bookingState.selectedTransportation.ibeUnit.price || bookingState.selectedTransportation.ibeProduct.price,
                    "package": null,
                    "lob": lobTitle,
                    "arrival_date": _this.getCleanDateStr(bookingState.selectedTransportation.ibeProduct.startDate)
                });
            }
        }
        if (trackedProducts.length) {
            obj.cart = {
                products: trackedProducts,
                total_cost: bookingState.booking.totalPrice,
                currency: (bookingState.booking.quote && bookingState.booking.quote.currency) || (bookingState.selectedIBEUnit && bookingState.selectedIBEUnit.currency)
            };
        }
        window.flowtracker = obj;
        console.log("build flow tracker obj: ", obj);
        this.dispatchIBEReadyGMTEvent();
    };
    TrackingService.dispatchIBEReadyGMTEvent = function () {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'ibe_ready'
        });
        console.log("dispatch ibe_ready", window.dataLayer);
    };
    TrackingService.getCleanDateStr = function (date) {
        if (!date)
            return date;
        date = String(date);
        if (date.indexOf('T') > 0) {
            date = date.substr(0, date.indexOf('T'));
        }
        return date;
    };
    ;
    TrackingService.getSegmentUserId = function () {
        var overlayCookieName = "ajs_anonymous_id";
        try {
            var cookies = document.cookie.split(";"); // Split the cookies string into an array
            for (var i = 0; i < cookies.length; i++) {
                var cookie = cookies[i].trim(); // Remove any leading/trailing whitespace
                if (cookie.startsWith(overlayCookieName + "=")) {
                    return cookie.substring(overlayCookieName.length + 1); // Extract the cookie value
                }
            }
        }
        catch (e) {
            console.log("getSegmentUserId:", e);
        }
        return null; // Cookie not found        
    };
    ;
    TrackingService.md5 = function (input) {
        //  A formatted version of a popular md5 implementation.
        //  Original copyright (c) Paul Johnston & Greg Holt.
        //  The function itself is now 42 lines long.
        var hc = "0123456789abcdef";
        function rh(n) { var j, s = ""; for (j = 0; j <= 3; j++)
            s += hc.charAt((n >> (j * 8 + 4)) & 0x0F) + hc.charAt((n >> (j * 8)) & 0x0F); return s; }
        function ad(x, y) { var l = (x & 0xFFFF) + (y & 0xFFFF); var m = (x >> 16) + (y >> 16) + (l >> 16); return (m << 16) | (l & 0xFFFF); }
        function rl(n, c) { return (n << c) | (n >>> (32 - c)); }
        function cm(q, a, b, x, s, t) { return ad(rl(ad(ad(a, q), ad(x, t)), s), b); }
        function ff(a, b, c, d, x, s, t) { return cm((b & c) | ((~b) & d), a, b, x, s, t); }
        function gg(a, b, c, d, x, s, t) { return cm((b & d) | (c & (~d)), a, b, x, s, t); }
        function hh(a, b, c, d, x, s, t) { return cm(b ^ c ^ d, a, b, x, s, t); }
        function ii(a, b, c, d, x, s, t) { return cm(c ^ (b | (~d)), a, b, x, s, t); }
        function sb(x) {
            var i;
            var nblk = ((x.length + 8) >> 6) + 1;
            var blks = new Array(nblk * 16);
            for (i = 0; i < nblk * 16; i++)
                blks[i] = 0;
            for (i = 0; i < x.length; i++)
                blks[i >> 2] |= x.charCodeAt(i) << ((i % 4) * 8);
            blks[i >> 2] |= 0x80 << ((i % 4) * 8);
            blks[nblk * 16 - 2] = x.length * 8;
            return blks;
        }
        var i, x = sb(input), a = 1732584193, b = -271733879, c = -1732584194, d = 271733878, olda, oldb, oldc, oldd;
        for (i = 0; i < x.length; i += 16) {
            olda = a;
            oldb = b;
            oldc = c;
            oldd = d;
            a = ff(a, b, c, d, x[i + 0], 7, -680876936);
            d = ff(d, a, b, c, x[i + 1], 12, -389564586);
            c = ff(c, d, a, b, x[i + 2], 17, 606105819);
            b = ff(b, c, d, a, x[i + 3], 22, -1044525330);
            a = ff(a, b, c, d, x[i + 4], 7, -176418897);
            d = ff(d, a, b, c, x[i + 5], 12, 1200080426);
            c = ff(c, d, a, b, x[i + 6], 17, -1473231341);
            b = ff(b, c, d, a, x[i + 7], 22, -45705983);
            a = ff(a, b, c, d, x[i + 8], 7, 1770035416);
            d = ff(d, a, b, c, x[i + 9], 12, -1958414417);
            c = ff(c, d, a, b, x[i + 10], 17, -42063);
            b = ff(b, c, d, a, x[i + 11], 22, -1990404162);
            a = ff(a, b, c, d, x[i + 12], 7, 1804603682);
            d = ff(d, a, b, c, x[i + 13], 12, -40341101);
            c = ff(c, d, a, b, x[i + 14], 17, -1502002290);
            b = ff(b, c, d, a, x[i + 15], 22, 1236535329);
            a = gg(a, b, c, d, x[i + 1], 5, -165796510);
            d = gg(d, a, b, c, x[i + 6], 9, -1069501632);
            c = gg(c, d, a, b, x[i + 11], 14, 643717713);
            b = gg(b, c, d, a, x[i + 0], 20, -373897302);
            a = gg(a, b, c, d, x[i + 5], 5, -701558691);
            d = gg(d, a, b, c, x[i + 10], 9, 38016083);
            c = gg(c, d, a, b, x[i + 15], 14, -660478335);
            b = gg(b, c, d, a, x[i + 4], 20, -405537848);
            a = gg(a, b, c, d, x[i + 9], 5, 568446438);
            d = gg(d, a, b, c, x[i + 14], 9, -1019803690);
            c = gg(c, d, a, b, x[i + 3], 14, -187363961);
            b = gg(b, c, d, a, x[i + 8], 20, 1163531501);
            a = gg(a, b, c, d, x[i + 13], 5, -1444681467);
            d = gg(d, a, b, c, x[i + 2], 9, -51403784);
            c = gg(c, d, a, b, x[i + 7], 14, 1735328473);
            b = gg(b, c, d, a, x[i + 12], 20, -1926607734);
            a = hh(a, b, c, d, x[i + 5], 4, -378558);
            d = hh(d, a, b, c, x[i + 8], 11, -2022574463);
            c = hh(c, d, a, b, x[i + 11], 16, 1839030562);
            b = hh(b, c, d, a, x[i + 14], 23, -35309556);
            a = hh(a, b, c, d, x[i + 1], 4, -1530992060);
            d = hh(d, a, b, c, x[i + 4], 11, 1272893353);
            c = hh(c, d, a, b, x[i + 7], 16, -155497632);
            b = hh(b, c, d, a, x[i + 10], 23, -1094730640);
            a = hh(a, b, c, d, x[i + 13], 4, 681279174);
            d = hh(d, a, b, c, x[i + 0], 11, -358537222);
            c = hh(c, d, a, b, x[i + 3], 16, -722521979);
            b = hh(b, c, d, a, x[i + 6], 23, 76029189);
            a = hh(a, b, c, d, x[i + 9], 4, -640364487);
            d = hh(d, a, b, c, x[i + 12], 11, -421815835);
            c = hh(c, d, a, b, x[i + 15], 16, 530742520);
            b = hh(b, c, d, a, x[i + 2], 23, -995338651);
            a = ii(a, b, c, d, x[i + 0], 6, -198630844);
            d = ii(d, a, b, c, x[i + 7], 10, 1126891415);
            c = ii(c, d, a, b, x[i + 14], 15, -1416354905);
            b = ii(b, c, d, a, x[i + 5], 21, -57434055);
            a = ii(a, b, c, d, x[i + 12], 6, 1700485571);
            d = ii(d, a, b, c, x[i + 3], 10, -1894986606);
            c = ii(c, d, a, b, x[i + 10], 15, -1051523);
            b = ii(b, c, d, a, x[i + 1], 21, -2054922799);
            a = ii(a, b, c, d, x[i + 8], 6, 1873313359);
            d = ii(d, a, b, c, x[i + 15], 10, -30611744);
            c = ii(c, d, a, b, x[i + 6], 15, -1560198380);
            b = ii(b, c, d, a, x[i + 13], 21, 1309151649);
            a = ii(a, b, c, d, x[i + 4], 6, -145523070);
            d = ii(d, a, b, c, x[i + 11], 10, -1120210379);
            c = ii(c, d, a, b, x[i + 2], 15, 718787259);
            b = ii(b, c, d, a, x[i + 9], 21, -343485551);
            a = ad(a, olda);
            b = ad(b, oldb);
            c = ad(c, oldc);
            d = ad(d, oldd);
        }
        return rh(a) + rh(b) + rh(c) + rh(d);
    };
    ;
    return TrackingService;
}());
export default TrackingService;
export function usePageViews() {
    var location = useLocation();
    React.useEffect(function () {
        // console.log("Track analytics: ", location.pathname);
        window.analytics && window.analytics.page(location.pathname);
    }, [location]);
}
